const raw = (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
export const galleryApi = path => `${raw}${raw.endsWith('/api') ? '' : '/api'}/gallery/${path}`;
